module.exports = __webpack_public_path__ + "img/mobile.e9e9cbd1.svg";